{
  "tabs": {
    "chat": "Pogovor",
    "reminders": "Opomniki",
    "calendar": "Koledar",
    "settings": "Nastavitve"
  },
  "common": {
    "cancel": "Prekliči",
    "save": "Shrani",
    "confirm": "Potrdi",
    "delete": "Izbriši",
    "back": "Nazaj",
    "close": "Zapri",
    "edit": "Uredi",
    "search": "Išči",
    "all": "Vse",
    "loading": "Nalaganje...",
    "error": "Nekaj je šlo narobe",
    "notFound": "Ni najdeno",
    "tryAgain": "Poskusite znova",
    "retry": "Ponovi",
    "undo": "Razveljavi",
    "pullToRefresh": "Povleci za osvežitev",
    "justNow": "ravnokar"
  },
  "auth": {
    "welcome": "Dobrodošli v FishMemory",
    "tagline": "Vaš WhatsApp pomočnik za opomnike, zdaj v žepu.",
    "subtitle": "Vaš WhatsApp pomočnik za opomnike, zdaj v žepu.",
    "phoneLabel": "Vaša WhatsApp številka",
    "phoneHint": "Poslali vam bomo potrditveno kodo preko WhatsApp",
    "invalidPhone": "Vnesite veljavno telefonsko številko",
    "continue": "Nadaljuj",
    "enterPhone": "Vnesite svojo WhatsApp številko",
    "phonePlaceholder": "Telefonska številka",
    "sendCode": "Pošlji kodo",
    "verifyTitle": "Potrdite svojo številko",
    "otpSentTo": "6-mestna koda je bila poslana na {{phone}} preko WhatsApp",
    "enterFullCode": "Vnesite vseh 6 številk",
    "invalidOtp": "Neveljavna koda. Poskusite znova.",
    "otpFailed": "Pošiljanje kode ni uspelo. Poskusite znova.",
    "otpResent": "Koda ponovno poslana",
    "resendIn": "Ponovno pošlji čez {{seconds}}s",
    "resendCode": "Ponovno pošlji kodo",
    "enterOtp": "Vnesite kodo, poslano na vaš WhatsApp",
    "verify": "Potrdi",
    "resend": "Ponovno pošlji kodo",
    "wrongNumber": "Napačna številka?",
    "backToPhone": "Nazaj na telefon",
    "editPhone": "Uredi telefonsko številko",
    "error": "Napaka",
    "setupTitle": "Nastavimo stvari",
    "setupSubtitle": "To lahko vedno spremenite kasneje v Nastavitvah",
    "namePlaceholder": "Vaše ime",
    "letsGo": "Dokončaj nastavitve",
    "skipForNow": "Preskoči za zdaj"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Vnesite sporočilo...",
    "inputPlaceholder": "Vnesite sporočilo...",
    "typing": "FishMemory tipka...",
    "online": "Na spletu",
    "connecting": "Povezujem...",
    "reconnecting": "Ponovno povezujem...",
    "offline": "Brez povezave",
    "empty": "Začnite pogovor",
    "emptyHint": "Ustvarite opomnike, preverite urnik ali prosite za pomoč.",
    "emptyAction": "Pošlji vzorčni opomnik",
    "actions": "Dejanja v pogovoru",
    "keep": "Shrani sporočila",
    "clearTitle": "Počisti pogovor",
    "clearConfirm": "Izbrišem vsa sporočila na tej napravi? Tega ni mogoče razveljaviti.",
    "clear": "Počisti pogovor",
    "optionSelected": "Izbrano: {{label}}",
    "sendingSelection": "Pošiljam...",
    "connectionLost": "Ponovno povezovanje..."
  },
  "reminders": {
    "title": "Moji opomniki",
    "active": "Aktivni",
    "today": "Danes",
    "thisWeek": "Ta teden",
    "history": "Zgodovina",
    "items": "elementi",
    "emptyTitle": "Še ni opomnikov",
    "emptySubtitle": "Ustvarite enega v pogovoru in prikazal se bo tukaj.",
    "emptyAction": "Odpri pogovor",
    "filterActive": "Aktivni",
    "filterToday": "Danes",
    "filterWeek": "Ta teden",
    "filterHistory": "Zgodovina",
    "emptyState": "Še ni opomnikov. Začnite pogovor!",
    "swipeDone": "Končano",
    "swipeSnooze": "Zamudi",
    "swipeDelete": "Izbriši",
    "search": "Išči opomnike...",
    "upcoming": "Prihajajoči",
    "completed": "Končani",
    "overdue": "Zamujeni",
    "tomorrow": "Jutri",
    "synced": "Sinhronizirano {{value}}",
    "swipeHint": "Povlecite opomnik za več možnosti",
    "noResults": "Ni opomnikov, ki ustrezajo iskanju",
    "noResultsHint": "Poskusite drugo ključno besedo ali počistite iskanje",
    "deleteAllFailed": "Brisanje vseh opomnikov ni uspelo"
  },
  "calendar": {
    "title": "Koledar",
    "today": "Danes",
    "tomorrow": "Jutri",
    "completed": "končano",
    "noEvents": "Ni načrtovanih dogodkov",
    "noEventsSubtitle": "Izberite datum za ogled opomnikov in dogodkov v koledarju.",
    "googleEvent": "Google Koledar",
    "legendActive": "Aktivno",
    "legendRecurring": "Ponavljajoče se",
    "legendDone": "Končano",
    "legendGoogle": "Google",
    "previousMonth": "Prejšnji mesec",
    "nextMonth": "Naslednji mesec",
    "previousYear": "Prejšnje leto",
    "nextYear": "Naslednje leto",
    "goToToday": "Pojdi na danes",
    "all": "Vse",
    "active": "Aktivno",
    "done": "Končano",
    "paused": "Zaustavljeno"
  },
  "settings": {
    "title": "Nastavitve",
    "profile": "Profil",
    "name": "Prikazano ime",
    "enterName": "Vnesite svoje ime",
    "language": "Jezik",
    "uiLanguage": "Jezik aplikacije",
    "uiLanguageHelp": "Spremeni jezik uporabniškega vmesnika, oznake koledarja in smer postavitve samo na tej napravi.",
    "serverLanguage": "Jezik pogovora",
    "serverLanguageHelp": "Spremeni jezik, ki ga strežnik uporablja za odgovore in sporočila opomnikov za vaš račun.",
    "timezone": "Časovni pas",
    "currentTimezone": "Trenutni časovni pas",
    "timezoneHelp": "Vsi časi opomnikov so prikazani v tem časovnem pasu.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Shrani časovni pas",
    "timezoneSaved": "Časovni pas posodobljen",
    "detect": "Zaznaj",
    "detectFailed": "Zaznavanje časovnega pasu ni uspelo",
    "autoDetect": "Samodejno zaznaj preko GPS",
    "notifications": "Obvestila",
    "notificationsHelp": "Opomniki za nadaljnje opomnike nadzorujejo ponavljajoče se opozorila po dostavi opomnika. Dovoljenja za obvestila na ravni naprave so še vedno upravljana v nastavitvah telefona.",
    "pushEnabled": "Potisna obvestila",
    "autoDoneOnFire": "Samodejno označi kot končano ob sprožitvi",
    "autoDoneOnFireDesc": "Če je izklopljeno, opomniki ostanejo aktivni, dokler jih ne označite kot končane.",
    "googleCalendar": "Google Koledar",
    "google": "Google Koledar",
    "googleConnected": "Povezano",
    "googleDisconnected": "Ni povezano",
    "googleConnectedHelp": "Novi opomniki se lahko samodejno sinhronizirajo z vašim koledarjem.",
    "googleDisconnectedHelp": "Povežite Google Koledar, da bodo opomniki in dogodki usklajeni.",
    "googleConnectFailed": "Povezava z Google Koledarjem ni uspela",
    "connected": "Povezano",
    "disconnected": "Ni povezano",
    "connect": "Poveži",
    "disconnect": "Prekini povezavo",
    "autoSync": "Samodejno sinhroniziraj nove opomnike",
    "autosync": "Samodejno sinhroniziraj nove opomnike",
    "subscription": "Naročnina",
    "trialUsed": "Preizkus: {{used}}/{{total}} uporabljenih",
    "trialStatus": "Preizkus na voljo",
    "activeStatus": "Aktivna naročnina",
    "expiredStatus": "Naročnina potekla",
    "unsubscribedStatus": "Niste naročeni",
    "about": "O aplikaciji",
    "version": "Različica",
    "logout": "Odjava",
    "logoutTitle": "Odjava",
    "logoutConfirm": "Ste prepričani, da se želite odjaviti?",
    "noName": "Ime ni nastavljeno",
    "serverConnection": "Povezava s strežnikom",
    "serverUrl": "URL strežnika",
    "serverEdit": "Uredi",
    "saveReconnect": "Shrani in ponovno poveži",
    "resetDefault": "Ponastavi na privzeto",
    "invalidServerUrlTitle": "Neveljaven URL strežnika",
    "invalidServerUrlMessage": "Vnesite veljaven http ali https URL strežnika, na primer https://example.com",
    "uiLanguageChangeFailed": "Sprememba jezika aplikacije ni uspela. Poskusite znova.",
    "serverLanguageChangeFailed": "Sprememba jezika pogovora ni uspela. Poskusite znova.",
    "timezoneChangeFailed": "Sprememba časovnega pasu ni uspela. Poskusite znova.",
    "autoSyncChangeFailed": "Posodobitev samodejne sinhronizacije ni uspela. Poskusite znova.",
    "nameChangeFailed": "Posodobitev prikazanega imena ni uspela. Poskusite znova.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Podrobnosti opomnika",
    "editTime": "Uredi čas",
    "rename": "Preimenuj",
    "snooze": "Zamudi",
    "snooze15": "Zamudi 15 minut",
    "pause": "Zaustavi",
    "pauseReminder": "Zaustavi opomnik",
    "resume": "Nadaljuj",
    "resumeReminder": "Nadaljuj opomnik",
    "skip": "Preskoči naslednjega",
    "skipOccurrence": "Preskoči to ponovitev",
    "syncGoogle": "Sinhroniziraj z Google",
    "delete": "Izbriši",
    "deleteTitle": "Izbriši opomnik",
    "deleteConfirm": "Ta opomnik bo trajno izbrisan.",
    "deleteRecurringTitle": "Izbriši ponavljajoči opomnik",
    "deleteRecurringMessage": "Želite preskočiti to ponovitev ali izbrisati celotno serijo?",
    "deleteThisOccurrence": "Preskoči to ponovitev",
    "deleteEntireSeries": "Izbriši celotno serijo",
    "done": "Končano",
    "markDone": "Označi kot končano",
    "undo": "Razveljavi",
    "undoPrompt": "Potrebujete, da je spet aktiven? Obnovite ga zdaj.",
    "recurring": "Ponavljajoče se",
    "nextRun": "Naslednji zagon",
    "oneTime": "Enkratni",
    "pending": "V teku",
    "sent": "Poslano",
    "paused": "Zaustavljeno",
    "active": "Aktivno",
    "snoozed": "Zamujeno",
    "localTime": "Prikazano v vašem lokalnem času",
    "recurrence": "Ponavljanje",
    "created": "Ustvarjeno",
    "tags": "Oznake",
    "fireCount": "Število sprožitev",
    "actions": "Dejanja",
    "none": "Brez",
    "snoozeFailed": "Zamuda opomnika ni uspela",
    "pauseFailed": "Zaustavitev opomnika ni uspela",
    "resumeFailed": "Nadaljevanje opomnika ni uspelo",
    "skipFailed": "Preskok opomnika ni uspel",
    "doneFailed": "Označevanje opomnika kot končanega ni uspelo",
    "undoFailed": "Obnova statusa opomnika ni uspela",
    "deleteFailed": "Brisanje opomnika ni uspelo",
    "rescheduleTitle": "Prekoordinirati?",
    "rescheduleMsg": "Ta opomnik je zamujen. Želite, da ga prestavite?",
    "reschedule15": "Čez 15 minut",
    "reschedule60": "Čez 1 uro",
    "keepOverdue": "Pusti kot je"
  },
  "onboarding": {
    "slide1Title": "Dobrodošli v FishMemory",
    "slide1Sub": "Vaš osebni pomočnik za opomnike — z močjo WhatsApp in narejen za vaš žep.",
    "slide2Title": "Preprosto klepetajte naravno",
    "slide2Sub": "Vnesite opomnike, kot jih mislite: \"Opomni me, da pokličem mamo jutri ob 15h\" — mi poskrbimo za ostalo.",
    "slide3Title": "Nikoli ne zamudite ničesar",
    "slide3Sub": "Prejemajte pravočasna obvestila, organizirajte z oznakami in ostanite na tekočem z vsem pomembnim.",
    "getStarted": "Začni",
    "next": "Naprej",
    "firstReminderTitle": "Ustvarite svoj prvi opomnik!",
    "firstReminderHint": "Poskusite vpisati nekaj takega:",
    "firstReminderExample": "Opomni me, da pijem vodo jutri ob 9h",
    "gotIt": "Razumem!",
    "notifRationaleTitle": "Bodite točni",
    "notifRationaleBody": "FishMemory potrebuje obvestila, da vas pravočasno opomni. Opozorila boste prejeli samo za opomnike, ki jih ustvarite.",
    "notifRationaleAllow": "Omogoči obvestila",
    "notifRationaleLater": "Morda kasneje",
    "swipeHint": "Povlecite desno za hitra dejanja →",
    "calendarDragHint": "Povlecite za razširitev ↕"
  }
}
